/***
 * @Authors:
 *      Rahul Kumar
 ***/

/*** Imports ***/

/* Library imports */
import axios from "axios";

/* Component imports */
import ConstantsLg from "../ConstantsLg";
import { FrontEndErrorEmail } from '../UtilityLg';
/*** End Imports ***/

export function verifyRecruiterEmail({ email, onSuccess, ...params }) {

    axios({
        timeout: ConstantsLg.REQ_TIMEOUT,
        method: 'get',
        url: ConstantsLg.ROUTE.REC_LOGIN,
        params: {
            action_type: ConstantsLg.ACTIONS.VERIFY_REC_EMAIL,
            email_address: email
        }
    }).then(res => {
        if (res.data && res.data.error === null) {
            onSuccess(res.data.data);
        } else {
            params.onFailure(res.data);
        }

    }).catch((error) => {
        params.onFailure(error);
        FrontEndErrorEmail(error);
    });
}

export function verifyFreelancerEmail({ email, onSuccess, ...params }) {

    axios({
        timeout: ConstantsLg.REQ_TIMEOUT,
        method: 'get',
        url: ConstantsLg.ROUTE.FREELANCER_LOGIN,
        params: {
            action_type: ConstantsLg.ACTIONS.VERIFY_FREELANCER_EMAIL,
            email_address: email
        }
    }).then(res => {
        if (res.data && res.data.error === null) {
            onSuccess(res.data.data);
        } else {
            params.onFailure(res.data);
        }

    }).catch((error) => {
        params.onFailure(error);
        FrontEndErrorEmail(error);
    });
}


export function signUpRecruiter({ email, onSuccess, ...params }) {

    axios({
        timeout: ConstantsLg.REQ_TIMEOUT,
        method: 'get',
        url: ConstantsLg.ROUTE.REC_LOGIN,
        params: {
            action_type: ConstantsLg.ACTIONS.SIGN_UP_REC,
            email_address: email
        }
    }).then(res => {
        if (res.data && res.data.error === null) {
            onSuccess(res.data.data);
        } else {
            params.onFailure(res.data);
        }

    }).catch((error) => {
        params.onFailure(error);
        FrontEndErrorEmail(error);
    });
}

export function loginFreelancer({ email, password, onSuccess, ...params }) {

    axios({
        timeout: ConstantsLg.REQ_TIMEOUT,
        method: 'get',
        url: ConstantsLg.ROUTE.FREELANCER_LOGIN,
        params: {
            action_type: ConstantsLg.ACTIONS.LOGIN,
            email_address: email,
            password: password
        }
    }).then(res => {
        if (res.data && res.data.error === null) {
            onSuccess(res.data.data);
        } else {
            params.onFailure(res.data);
        }

    }).catch((error) => {
        params.onFailure(error);
        FrontEndErrorEmail(error);
    });
}



export function signUpFreelancer({ email, onSuccess, ...params }) {

    axios({
        timeout: ConstantsLg.REQ_TIMEOUT,
        method: 'get',
        url: ConstantsLg.ROUTE.FREELANCER_LOGIN,
        params: {
            action_type: ConstantsLg.ACTIONS.SIGN_UP_FREELANCER,
            email_address: email
        }
    }).then(res => {
        if (res.data && res.data.error === null) {
            onSuccess(res.data.data);
        } else {
            params.onFailure(res.data);
        }

    }).catch((error) => {
        params.onFailure(error);
        FrontEndErrorEmail(error);
    });
}

export function loginRecruiter({ email, password, onSuccess, ...params }) {

    axios({
        timeout: ConstantsLg.REQ_TIMEOUT,
        method: 'get',
        url: ConstantsLg.ROUTE.REC_LOGIN,
        params: {
            action_type: ConstantsLg.ACTIONS.LOGIN,
            email_address: email,
            password: password
        }
    }).then(res => {
        if (res.data && res.data.error === null) {
            onSuccess(res.data.data);
        } else {
            params.onFailure(res.data);
        }

    }).catch((error) => {
        params.onFailure(error);
        FrontEndErrorEmail(error);
    });
}


export function resetPassword({ email, onSuccess, ...params }) {


    axios({
        timeout: ConstantsLg.REQ_TIMEOUT,
        method: 'get',
        url: ConstantsLg.ROUTE.REC_LOGIN,
        params: {
            action_type: ConstantsLg.ACTIONS.RESET_PSWD,
            email_address: email
        }
    }).then(res => {
        if (res.data && res.data.error === null) {
            onSuccess(res.data.data);
        } else {
            params.onFailure(res.data);
        }

    }).catch((error) => {
        params.onFailure(error);
        FrontEndErrorEmail(error);
    });
}

export function resetFreelancerPassword({ email, onSuccess, ...params }) {

    //this is for Freelancer

    axios({
        timeout: ConstantsLg.REQ_TIMEOUT,
        method: 'get',
        url: ConstantsLg.ROUTE.FREELANCER_LOGIN,
        params: {
            action_type: ConstantsLg.ACTIONS.RESET_PSWD_FREELANCER,
            email_address: email
        }
    }).then(res => {
        if (res.data && res.data.error === null) {
            onSuccess(res.data.data);
        } else {
            params.onFailure(res.data);
        }

    }).catch((error) => {
        params.onFailure(error);
        FrontEndErrorEmail(error);
    });
}


export function requestSignOut(data, callBackSuccess, callBackFailure) {

    let CancelToken = axios.CancelToken;

    let cancelGetServerCall = null;

    axios({
        timeout: 120 * 1000,
        method: 'post',
        url: '/logoutweb',
        // withCredentials:true,
        cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            cancelGetServerCall = c;
        }),
        data: data

    }).then(res => {

        if (res.data.error === null) {
            callBackSuccess()
        } else {
            callBackFailure();
        }
        //    if success close the modal and set state in calling calling component
        //    or make auth chack
    }).catch(error => {
        console.log(error);
        callBackFailure();
        FrontEndErrorEmail(error);
    });

    return cancelGetServerCall;
}

export function xhrVerifyProfessionalEmail(data, onSuccess, onFailure) {

    axios({
        timeout: ConstantsLg.REQ_TIMEOUT,
        method: 'get',
        url: ConstantsLg.ROUTE.PROF_LOGIN_BY_EMAIL,
        params: {
            action_type: ConstantsLg.ACTIONS.VERIFY_PROF_EMAIL,
            email_address: data.email
        }
    }).then(res => {
        if (res.data && res.data.error === null) {
            onSuccess(res.data.data);
        } else {
            onFailure(res.data);
        }

    }).catch((error) => {
        onFailure(error);
        FrontEndErrorEmail(error);
    });
}


export function loginProfessional({ email, password, onSuccess, ...params }) {

    axios({
        timeout: ConstantsLg.REQ_TIMEOUT,
        method: 'get',
        url: ConstantsLg.ROUTE.PROF_LOGIN_BY_EMAIL,
        params: {
            action_type: ConstantsLg.ACTIONS.LOGIN,
            email_address: email,
            password: password
        }
    }).then(res => {
        if (res.data && res.data.error === null) {
            onSuccess(res.data.data);
        } else {
            params.onFailure(res.data);
        }

    }).catch((error) => {
        params.onFailure(error);
        FrontEndErrorEmail(error);
    });
}

export function signUpProfessional({ email, onSuccess, ...params }) {

    axios({
        timeout: ConstantsLg.REQ_TIMEOUT,
        method: 'get',
        url: ConstantsLg.ROUTE.PROF_LOGIN_BY_EMAIL,
        params: {
            action_type: ConstantsLg.ACTIONS.SIGN_UP_PROFESSIONAL,
            email_address: email
        }
    }).then(res => {
        if (res.data && res.data.error === null) {
            onSuccess(res.data.data);
        } else {
            params.onFailure(res.data);
        }

    }).catch((error) => {
        params.onFailure(error);
        FrontEndErrorEmail(error);
    });
}

export function resetPasswordProfessional({ email, onSuccess, ...params }) {

    //this is for recruiter

    axios({
        timeout: ConstantsLg.REQ_TIMEOUT,
        method: 'get',
        url: ConstantsLg.ROUTE.PROF_LOGIN_BY_EMAIL,
        params: {
            action_type: ConstantsLg.ACTIONS.RESET_PSWD_PROFESSIONAL,
            email_address: email
        }
    }).then(res => {
        if (res.data && res.data.error === null) {
            onSuccess(res.data.data);
        } else {
            params.onFailure(res.data);
        }

    }).catch((error) => {
        params.onFailure(error);
        FrontEndErrorEmail(error);
    });
}

export function FrontEndErrorNotification(parms, onSuccess, onFailure) {

    axios({
        timeout: ConstantsLg.REQ_TIMEOUT,
        method: 'post',
        url: ConstantsLg.ROUTE.FRONTEND_ERROR_NOTIFICATION,
        data: parms
    }).then(res => {
        // let data = res.data.data ;

        //Some initial processing like Valid User Check
        //finally call success as success call was success handle other cases in callback function

        onSuccess();
    }).catch((error) => {
        onFailure();
    });
}


// WEBPACK FOOTER //
// ./src/Services/services.js